import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"work_outline"}/>
}
